import { useEffect, useState } from "react";

export function useMessageBar() {
  const [message, setMessage] = useState(null);
  useEffect(() => {
    // Clear error after 10 seconds
    const handle = setTimeout(() => setMessage(null), 10000);
    return () => {
      clearTimeout(handle);
    };
  }, [message]);
  return [message, setMessage];
}
